import { BlockT, ModelBase, ModelUtils, Point } from "pytha";

export class HvacVortexFanT extends BlockT {
    type = 'HvacVortexFanT';

    setPosition(position: Point) {
        this.position = position;
    }

    setEntities(entities: ModelBase[]): void {
        this._entities = entities;
    }

    setNormal(normal: any) {
        this.normal = normal;
    }

    setAxisX(axisX: any) {
        this.axisX = axisX;
    }

    clone() {
        const entity = new HvacVortexFanT().copy(this);
        entity.uuid = ModelUtils.generateUUID();
        return entity;
    }

    toJson() {
        let parentJson = super.toJson();
        let data = {
            ...parentJson,
            type: this.type,
        }

        return data;
    }

    fromJson(json) {
        super.fromJson(json);
        return this;
    }

}